module.exports = __webpack_public_path__ + "img/zhongshan6.60e1b173.jpg";